












































































import {
	ActivityTypeEnum,
	ApplicationUserModel,
	PartyActivityModel,
	PartyModel, PartyPrintModel,
	PartyPrintTypeEnum,
	TenantUserModel
} from '@/libs/Api';
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { partyActivitiesStore } from '@/libs/party-activities/+state/store';
import { CrudAction, CrudReponse, CrudResponseAction } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import moment from 'moment';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { Guid } from '@/libs/common/functions/guid';

import { cloneDeep } from 'lodash';
import { partiesStore } from '../+state/store';
import Page from '@/Page.vue';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import ApiService from "@/libs/core/api-service";
import {b64toBlob} from "@/libs/common/functions/b64toBlob";

@Component
export default class ClientEvaluations extends Page {

    newComment: string | null = null;
    commentsList: PartyActivityModel[] = [];
    itemToEdit: string | null = null;
    creating = false;
    saving: string | null = Guid.EmptyGuid();
    deleting: string | null = Guid.EmptyGuid();
    user = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
	printing = false;

    get today(): string {
        return moment().format("DD.MM.YYYY");
    }

    get party(): PartyModel {
        return {...partiesStore.useGetter(CrudGetter.Detail)} as PartyModel;
    }

    get comments (): PartyActivityModel[] {
        return partyActivitiesStore.useGetter(CrudGetter.Data, this.partyId);
    }

    get loading(): boolean {
        return partyActivitiesStore.useGetter(CrudGetter.Pending);
    }

    /* Auth variables */
    tenantUser: TenantUserModel = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;

    @Prop() tenantId!: string;
    @Prop() partyId!: string;

    @Watch("comments")
    commentsChanged (v: PartyActivityModel[]) {
        this.commentsList = cloneDeep(v);
    }

    @Watch("id")
    idChanged () {
        this.loadEvaluations();
    }
    
    mounted () {
        this.loadEvaluations();
    }

    loadEvaluations() {
        partyActivitiesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<PartyActivityModel>([{ field: "createdAt", index: 0, order: "desc" }], [
            { field: "partyId", op: "eq", comparand: this.partyId },
            { field: "type", op: "eq", comparand: ActivityTypeEnum.Evaluation }
        ], undefined, false, this.partyId));
    }

    createEvaluation () {
        const newItem = {
            id: Guid.EmptyGuid(),
            description: this.newComment,
            partyId: this.party.id,
            type: ActivityTypeEnum.Evaluation,
            createdById: this.user.id,
            tenantUserId: this.tenantUser.id
        } as PartyActivityModel;
        partyActivitiesStore.dispatch(CrudAction.Create, { item: newItem, key: this.partyId });
        this.creating = true;
        this.subscribe(partyActivitiesStore, CrudReponse.Create, this.partyId).then((e: PartyActivityModel) => {
            this.newComment = null;
            this.creating = false;
        }).catch((e: any) => {
            this.creating = false;
        });
    }

    deleteEvaluation (item: PartyActivityModel) {
        partyActivitiesStore.dispatch(CrudAction.Delete, createCrudQueryPayload(undefined, [{ field: "id", op: "eq", comparand: item.id! }], undefined, false, this.partyId));
        this.deleting = item!.id!;
        this.subscribe(partyActivitiesStore, CrudReponse.Delete, this.partyId).then((e: any) => {
            this.deleting = null;
        }).catch((e: any) => {
            this.deleting = null;
        });
    }

    editEvaluation (item: PartyActivityModel) {
        this.itemToEdit = item.id!;
    }

    saveEvaluation () {
        if (this.itemToEdit != null) {
            this.saving = this.itemToEdit;
            const item = this.commentsList.find(x => x.id == this.itemToEdit);
            partyActivitiesStore.dispatch(CrudAction.Update, { item: item, key: this.partyId });
            const self = this;
            this.saving = item!.id!;
            this.subscribe(partyActivitiesStore, CrudReponse.Update, this.partyId).then((e: any) => {
                this.itemToEdit = null;
                this.saving = null;
            }).catch((e: any) => {
                this.saving = null;
            });
        }
    }

    getInitials (v: string) {
        let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

        let initials: any = [...v.matchAll(rgx)] || [];

        initials = (
            (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
        ).toUpperCase();

        return initials;
    }

	printClick(): void {
		this.printing = true;
		const printModel = {
			printType: PartyPrintTypeEnum.Evaluations
		} as PartyPrintModel;
		ApiService.api.printParty(this.partyId, printModel).then((x: any) => {
			this.printing = false;
			const res = x.data;
			const blob = b64toBlob(res.returnValue.base64, res.returnValue.contentType);
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.setAttribute('download', res.returnValue.filename!);
			document.body.appendChild(link);
			link.click();
			link.parentNode!.removeChild(link);
		}).catch(() => {
			this.printing = false;
		});
	}

}
